import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { BaseUIContainerComponent } from './base-ui-container/base-ui-container.component';
import { AuthenticationGuard } from '../core/guards';

//this is to me removed once the Agent Hierarchy Modules are moved to ViewModules
import { ClaimsAuthenticationGuard } from '../../ViewModules/Claims/claims-guards'

/* Demos -- Component Demos -- Can be removed */
import { DemoDashComponent } from './demo/demo-dash/demo-dash.component';
import { DemoSandboxComponent } from './demo/demo-sandbox/demo-sandbox.component';
import { CaptureProposalComponent } from './demo/capture-proposal/capture-proposal.component';
import { DemoInboxUwComponent } from './demo/demo-inbox-uw/demo-inbox-uw.component';
import { DemoResponsiveTableComponent } from './demo/demo-responsive-table/demo-responsive-table.component';
import { UIOcrBaseComponent } from './ui-components/ocr-base/ocr-base.component';
// Agent Hierarchy 
import { OrgHierarchyComponent } from './demo/org-hierarchy/org-hierarchy.component';
import { OrgAgentsComponent } from './demo/org-agents/org-agents.component';
// Claims
import { DemoClaimsInboxComponent } from './demo/demo-claims/demo-claims-inbox.component';
import { DemoClaimsDetailsComponent } from './demo/demo-claims/demo-claims-details.component';
import { DemoClaimsIntimationComponent } from './demo/demo-claims/demo-claims-intimation/demo-claims-intimation.component';
import { DemoClaimsRegistrationComponent } from './demo/demo-claims/demo-claims-registration/demo-claims-registration.component';
import { ClaimsIntimationBulkUploadComponent } from './demo/demo-claims/claims-intimation-bulk-upload/claims-intimation-bulk-upload.component';

/* Customer 360 */
import { CustomerDashComponent_demo } from './demo/customer/customer-dash.component';
import { CustomerDetailsComponent_demo } from './demo/customer/customer-details/customer-details.component';
/* Profile */
import { UiProfileEditComponent } from 'app/BaseFramework/base-ui/ui-components/ui-profile-edit/ui-profile-edit.component';
import { ServicingInboxComponent_demo } from 'app/BaseFramework/base-ui/servicing-inbox/servicing-inbox.component';

/* END Demos -- Component Demos -- Can be removed */

/* Demo App Subroutes */
var subroutes = [
    { path: 'dash', component: DemoDashComponent, data: { breadcrumb: 'Dashboard' } },
    { path: 'inbox', component: DemoInboxUwComponent, data: { breadcrumb: 'Inbox' } },
    { path: 'capture-proposal', component: CaptureProposalComponent, data: { breadcrumb: 'Capture Proposal' } },
    { path: 'sandbox', component: DemoSandboxComponent, data: { breadcrumb: 'Sandbox' } },
    { path: 'responsive-tables', component: DemoResponsiveTableComponent, data: { breadcrumb: 'Responsive Tables' } },
    { path: 'ocr-base', component: UIOcrBaseComponent, data: { breadcrumb: 'OCR' } },
    /* Org Hierarchy */
    { path: 'org-agents', canActivate: [ClaimsAuthenticationGuard], component: OrgAgentsComponent, data: { breadcrumb: 'Agents' } },
    { path: 'org-hierarchy', canActivate: [ClaimsAuthenticationGuard], component: OrgHierarchyComponent, data: { breadcrumb: 'Org. Hierarchy' } },
    /* Claims */
    { path: 'claims', loadChildren: () => import('../../ViewModules/Claims/claims.module').then(m => m.ClaimsModule) },
    { path: 'claimsdemo/inbox', component: DemoClaimsInboxComponent, data: { breadcrumb: 'Claims Inbox' } },
    { path: 'claimsdemo/details', component: DemoClaimsDetailsComponent, data: { breadcrumb: 'Claim Details' } },
    { path: 'claimsdemo/details/:from', component: DemoClaimsDetailsComponent, data: { breadcrumb: 'Create' } },
    { path: 'claimsdemo/intimation', component: DemoClaimsIntimationComponent, data: { breadcrumb: 'Claim Intimation' } },
    { path: 'claimsdemo/intimation-bulk-upload', component: ClaimsIntimationBulkUploadComponent, data: { breadcrumb: 'Bulk Upload Intimations' } },
    { path: 'claimsdemo/registration', component: DemoClaimsRegistrationComponent, data: { breadcrumb: 'Claim Registration' } },

    /* Customer 360 */
    { path: 'customer360', component: CustomerDashComponent_demo, data: { breadcrumb: 'Customer 360' } },
    { path: 'customer360/details', component: CustomerDetailsComponent_demo, data: { breadcrumb: 'Customer 360' } },
    { path: 'customer360/details/:from', component: CustomerDetailsComponent_demo, data: { breadcrumb: 'Customer 360' } },
    /* Servicing */
    { path: 'servicing', component: ServicingInboxComponent_demo, data: { breadcrumb: 'Servicing' } },
    /* Profile */
    { path: 'profile-edit', component: UiProfileEditComponent, data: { breadcrumb: 'Edit Profile' } },

    /*NBU*/
    { path: 'nbu', loadChildren: () => import('../../ViewModules/Newbusiness/newbusiness.module').then(m => m.NewBusinessModule) },

    /*Policy Servicing*/
    { path: 'policyServicing', loadChildren: () => import('../../ViewModules/PolicyServicing/policyServicing.module').then(m => m.PolicyServicingModule) },
];

const routes: Routes = [
    {
        path: '',
        component: BaseUIContainerComponent,
        children: [
            {
                path: '',
                component: LoginComponent,
                data: {
                    breadcrumb: 'Login'
                }
            },
            {
                path: 'login',
                component: LoginComponent,
                data: {
                    breadcrumb: 'Login'
                }
            },
            {
                path: 'app',
                component: AppLayoutComponent,
                canActivate: [AuthenticationGuard, ClaimsAuthenticationGuard],
                children: [
                    ...subroutes
                ]
            },

        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})

export class BaseUIRoutingModule { }
